import { RefObject } from 'react';
import { twJoin } from 'tailwind-merge';

type StickyBarProps = {
    stickyRef: RefObject<HTMLDivElement> | null;
    isSticky: boolean;
    dataTestId?: string;
};

const TEST_IDENTIFIER = 'sticky-bar';

const StickyBar: FC<StickyBarProps> = ({ stickyRef, isSticky, dataTestId, children }) => {
    return (
        <div
            data-testid={dataTestId ?? TEST_IDENTIFIER}
            ref={stickyRef}
            className={twJoin(
                'left-0 right-0 top-[-1px] z-stickyBar transition-shadow',
                isSticky ? 'sticky bg-white shadow-grayDown' : 'static bg-none shadow-none',
            )}
        >
            {children}
        </div>
    );
};

export default StickyBar;
